import script from "./BookProductPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BookProductPage.vue?vue&type=script&setup=true&lang=js"

import "./BookProductPage.vue?vue&type=style&index=0&id=52ba7500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52ba7500"]])

export default __exports__